import React, { Component } from 'react';
import { Text } from '@cuemath/comps';
import COLORS from 'constants/colors';

export const MessageText = ({ message }) => {
  return (
    <Text color={COLORS.RED} size="larger" weight="bolder">
      {message}
    </Text>
  );
};
